let pending = false;
const listeners = new Set<() => void>();
export function requestMeetingRecording() {
  pending = true;
  for (const listener of listeners) listener();
}
export function consumeMeetingRecordingRequest() {
  const value = pending;
  pending = false;
  return value;
}
export function onMeetingRecordingRequest(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
